import {useCallback, useEffect, useRef} from 'react'
import {fetchQuery, useRelayEnvironment} from 'react-relay'
import {createOperationDescriptor, getRequest} from 'relay-runtime'
import type {RelayObservable} from 'relay-runtime/lib/network/RelayObservable'
import type {GraphQLTaggedNode} from 'relay-runtime/lib/query/RelayModernGraphQLTag'
import type {Disposable, OperationType} from 'relay-runtime/lib/util/RelayRuntimeTypes'

export function useOnDemandQuery<T extends OperationType>(query: GraphQLTaggedNode) {
  const environment = useRelayEnvironment()
  const disposables = useRef<Disposable[]>([])
  useEffect(
    () => () => {
      disposables.current.forEach(disposable => disposable.dispose())
    },
    [],
  )

  return useCallback(
    (variables: T['variables'], force?: boolean): RelayObservable<T['response']> => {
      disposables.current.push(
        environment.retain(createOperationDescriptor(getRequest(query), variables)),
      )
      return fetchQuery(environment, query, variables, {
        fetchPolicy: force ? 'network-only' : 'store-or-network',
        networkCacheConfig: {metadata: {isRefetch: force}},
      })
    },
    [environment, query],
  )
}
